<template>
  <base-window-list
    :headers="headers"
    title="Listado de Estado de Asignacion"
    :company="comdes"
    addMethod="itemsEstadoAsignacion"
    closeBaseWindow='addEstadoAsignacion'
    titleAddMethod="Agregar Estado de Asignacion"
    itemStoreName="itemsEstadoAsignacion"
    :loading="loadingResult"
    :activarEdicion="true"
    :activarBorrar="true"
    :activarInternalForm="true"
    :formProperties="{
      creacion: 'Creacion de Estado de Asignacion',
      edicion: 'Editar Estado de Asignacion',
      url: `/transjuma/EstadoAsignacion/`
    }"
    v-on:selected-row="handleEvent"
    v-on:updated="updatedList"
  ></base-window-list>
</template>

<script>
import { mapState } from 'vuex'
import BaseWindowList from '@/components/BaseWindowListGeneral'
import { paginationMethods } from '@/mixins/pagination'
export default {
  components:{
    BaseWindowList
  },
  mixins: [paginationMethods],
  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'center',
          value: 'id',
          colmd: 4,
          form: false,
          require: true,
          vtext: true,
        },
        {
          text: 'Nombre',
          align: 'center',
          value: 'nombre',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
        },
        {
          text: 'Codigo',
          align: 'center',
          value: 'codigo',
          colmd: 12,
          form: true,
          require: true,
          vtext: true,
          type: 'number'
        },
        {
          text: 'Acciones',
          align: 'center',
          value: 'actions',
          require: true,
        },
      ],
      loadingResult: true
    }
  },
  computed:{
    ...mapState([
      'addEstadoAsignacion',
    ]),
    company(){
      return this.$store.state.AuthModule.refu
    },
    comdes(){
      return 'Transjuma'
    }
  },
  methods: {
    handleEvent(item) {
      this.$emit('EstadoAsignacion-selected', item)
    },
    updatedList(){
      this.$store.dispatch('clearCatalog', 'estadoAsignaciones')
      this.getData()
    },
    async getData(){
      await this.$store.dispatch('AuthModule/verifyToken')
      console.log('BUSCANDO LOS DATOS')
      const obj = {
        token : this.$store.state.AuthModule.accessToken,
        method: 'GET',
        url: 'transjuma/EstadoAsignacion/',
        // body: body
        params:{
          ids: 1
        }
      }
      // this.loadingTable = true
      this.$store.dispatch('fechData', obj)
        .then((result) => {
          this.$store.dispatch('actItemsBaseWindowsList',{data: result, nombre: 'itemsEstadoAsignacion'})
          this.loadingResult = false
        })
        .catch((err) => {
          const regex = /["[{\]}]/g
          const mensaje = JSON.stringify(err.response.data).replaceAll(regex,'') ?? ''
          this.showAlert('error', mensaje)
          this.loadingResult = false
          if (err.response.status == 401){
            alert(
              `token no valido o vencido:  ${err.response.data.detail ?? ''}`
            )
            this.$router.push({name: 'LoginView'})
          }
        })
    }
  },
  created() {
    this.$store.state.itemsEstadoAsignacion = []
    this.getData()
  }
}
</script>

<style>

</style>